__turbopack_context__.v({
  "announcementBanner": "notification-bar-module-scss-module__7sz0kq__announcementBanner",
  "announcementBannerWrapper": "notification-bar-module-scss-module__7sz0kq__announcementBannerWrapper",
  "cta_announcement": "notification-bar-module-scss-module__7sz0kq__cta_announcement",
  "dark": "notification-bar-module-scss-module__7sz0kq__dark",
  "message": "notification-bar-module-scss-module__7sz0kq__message",
  "registerNow": "notification-bar-module-scss-module__7sz0kq__registerNow",
  "type": "notification-bar-module-scss-module__7sz0kq__type",
});
